import React, { ReactNode, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

import { GridColDef, GridComparatorFn } from '@mui/x-data-grid';

import DataTable from '../../components/DataTable';
import SearchField from '../../common/searchField';

import { palette } from '../../theme/palette';
import { ReactComponent as FilterIcon } from '../../assets/icons/main/filter-icon.svg';
import { ReactComponent as VrLineIcon } from '../../assets/vr-line.svg';
// import { ReactComponent as ConnectionCheckIcon } from '../../assets/connection-check-icon.svg';
// import { ReactComponent as ConnectionRemoveIcon } from '../../assets/connection-remove-icon.svg';
// import { ReactComponent as ConnectionIcon } from '../../assets/connection-bg-icon.svg';
import { ReactComponent as FullScreenIcon } from '../../assets/full-screen-icon.svg';
import { ReactComponent as FullScreenExitIcon } from '../../assets/fullscreen-exit-icon.svg';
import { ReactComponent as AlertIcon } from '../../assets/alert-icon.svg';
import { ReactComponent as AlertRedIcon } from '../../assets/alert-red-icon.svg';
import { ReactComponent as BellIcon } from '../../assets/icons/main/bell-icon.svg';
import Grid from '@mui/material/Grid';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import SelectComponent from '../../components/Select';
import { useDispatch } from 'react-redux';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
// import Modal from '../../common/Modal';

// import AssetsTable from './assetsTable';
// import GatewaysTable from './gatewaysTable';
import NotificationsTable from './notificationsTablel';
import AssetsOnboardingStatusChart from './assetsOnboardingStatusChart';
import TelemetryDataIngestionChart from './telemetryDataIngestionChart';
import CircularProgress from '@mui/material/CircularProgress';
import Connections from './connections';
import { connectivityDashboardActions } from '../../store/reducers/connectivity-dashboard';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import IconButton from '@mui/material/IconButton';
// import MqBrokerTable from './mqBrokerTable';
// import InfluxTable from './influxTable';
import UIServerTable from './uiServerTable';
import BackendServerTable from './backendServerTable';
import { gatewayMasterActions } from '../../store/reducers/gateway-master';
import {
  AssetsOnboardingDataRequestPayloadTypes,
  AssetsRequestPayloadTypes,
  TelemtryIngestionDataRequestPayloadTypes,
} from '../../store/models/connectivity-dashboard';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import dayjs from 'dayjs';
import Tooltip from '@mui/material/Tooltip';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';

import { ReactComponent as PlcConnected } from '../../assets/connectivitydashboard/plc-connected-icon.svg';
import { ReactComponent as PlcDisconnected } from '../../assets/connectivitydashboard/plc-disconnected-icon.svg';
import { ReactComponent as GatewayConnectedIcon } from '../../assets/connectivitydashboard/gateway-connected-icon.svg';
import { ReactComponent as GatewayDisconnectedIcon } from '../../assets/connectivitydashboard/gateway-disconnected-icon.svg';
import { ReactComponent as EmqxConnectedIcon } from '../../assets/connectivitydashboard/emqx-connected-icon.svg';
import { ReactComponent as EmqxDisconnectedIcon } from '../../assets/connectivitydashboard/emqx-disconnected-icon.svg';
import { ReactComponent as DataConnected } from '../../assets/connectivitydashboard/database-connected-icon.svg';
import { ReactComponent as DataDisconnected } from '../../assets/connectivitydashboard/database-disconnected-icon.svg';

import './connectivity.css';
import LatestMessagePopup from './latestMessagePopup';
import FilterData from '../../common/filterData';

import { convertUTCtoLocal } from '../../utils/time-converter';
import { lighten, useTheme } from '@mui/material';
import get from 'lodash/get';

const Styles = {
  pageWrapper: { display: 'flex', flexDirection: 'column', rowGap: 4 },
  filterContainer: {
    wrapper: { display: 'flex', alignItems: 'center', height: 32 },
    filterByTextWrapper: { display: 'flex', gap: 2, width: 140, mr: 2 },
    stack: {
      '&.MuiStack-root>:not(style)~:not(style)': { marginLeft: 2 },
      overflow: 'auto',
    },
    chip: {
      borderRadius: '8px',
      '& .MuiChip-label': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
  tableContainer: {
    container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px', height: '100%' },
    paper: {
      margin: 'auto',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid #D9DFED`,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    viewAllBtnWrapper: { display: 'flex', justifyContent: 'end', p: 2 },
  },
  chartWrapper: {
    container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
    paper: {
      margin: 'auto',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid #D9DFED`,
      // height: 560,
      minHeight: 260,
      // maxHeight: 560,
    },
    headerWrapper: {
      p: '22px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      boxSizing: 'border-box',
      flexWrap: 'wrap',
      rowGap: 1,
      // '@media (min-width:769px)': {
      //   height: '87px',
      // },
    },
    selectWrapper: { display: 'flex', alignItems: 'center', columnGap: 2, justifyContent: 'flex-end' },
    select: {
      fontSize: '16px',
    },
    selectMenuProps: {
      PaperProps: {
        sx: {
          '&.MuiPaper-root': {
            border: '1px solid #D9DFED',
            boxShadow:
              '0px 2px 2px -3px rgba(0,0,0,0.1),0px 4px 10px 1px rgba(0,0,0,0.1),0px 1px 14px 1px rgba(0,0,0,0.1)',
          },
          '& .MuiList-root': {
            padding: '0px',
          },
          '& .MuiMenuItem-root': {
            color: '#64759F',
            fontWeight: 400,
            fontSize: '16px',
            paddingLeft: '14px',
            paddingRight: '14px',
          },
        },
      },
    },
    bodyWrapper: {
      // pt: 7,
      // pb: 6,
      // minHeight: 400,
      // maxHeight: 400,
      // width: '100%',
      // height: 424,
      minHeight: 210,
      // maxHeight: 424,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'end',
      position: 'relative',
      padding: 3,
    },
    loadingWrapper: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      // backgroundColor: 'rgba(255, 255, 255, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  // cardsContainer: {
  //   wrapper: {
  //     // mt: 4,
  //     display: 'flex',
  //     flexWrap: 'wrap',
  //     // justifyContent: 'space-between',
  //     gap: 3,
  //   },
  //   card: { width: '188px' },
  //   cardContent: {
  //     p: 0,

  //     '&:last-child': {
  //       pb: 0,
  //     },
  //   },
  //   assetsWrapper: {
  //     display: 'flex',
  //     justifyContent: 'space-between',
  //     mt: 2,
  //   },
  //   asset: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     gap: 1,
  //   },
  // },
  dataTable: {
    '& .MuiDataGrid-virtualScroller': {
      pb: 0,
      overflow: 'auto',
      overflowY: 'hidden',
      // minHeight: '100%',
      height: '100%',
      minHeight: '280px !important',
      // maxHeight: 670,
    },
    '&.MuiDataGrid-root': {
      minHeight: '280px !important',
      // height: '100%',
      // minHeight: '100%',
      // height: 736,
      // minHeight: 210,
      // '& .MuiDataGrid-row:hover': {
      //   backgroundColor: 'initial',
      // },
    },
    '.MuiDataGrid-columnHeader': {
      height: '48px !important',
    },
    '.MuiDataGrid-columnHeaders': {
      minHeight: '48px !important',
      maxHeight: '48px !important',
      lineHeight: '48px !important',
    },

    '& .MuiDataGrid-iconButtonContainer': {
      marginLeft: '2px',
      visibility: 'visible !important',
      width: 'auto !important',
    },
    // '.MuiDataGrid-overlayWrapper': {
    //   minHeight: '300px',
    // },
  },
  tableCellText: {
    fontSize: '16px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  severityChip: {
    '& .MuiChip-label': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  chartModal: {
    paperProps: {
      sx: {
        padding: '32px',
        borderRadius: '18px',
        // backgroundColor: `${palette.transparent.main}`,
        width: '70%',
        maxWidth: '70%',
        height: '90%',
      },
    },
    dailogContent: {
      '&.MuiDialogContent-root': {
        padding: '0px',
        // backgroundColor: `${palette.primary.contrastText}`,
        borderRadius: '18px',
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 2,
    },
    dailogTitle: {
      fontSize: '20px',
      fontFamily: 'Open Sans',
      fontWeight: '400',
      p: 0,
    },
    headerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 2,
    },
    bodyWrapper: {
      width: '100%',
      height: 'calc(100% - 150px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
    },
    loadingWrapper: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    closeBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      pt: 2,
      pb: 2,
    },
  },
  notificationsTableWrapper: {
    paddingInline: 3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    height: '87px',
  },
  notificationsTable: {
    '& .MuiDataGrid-virtualScroller': {
      pb: 1,
      overflow: 'auto',
    },
    '&.MuiDataGrid-root': {
      height: 400,
      minHeight: 400,
    },
  },
  notificationsTableSearchWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
  notificationsTableSearch: { fontSize: '16px', width: '300px' },
  // Gateways & Assets Table
  gatewaysAssetsTableWrapper: {
    paddingInline: 3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    height: '87px',
  },
  gatewaysAssetsTab: { '&.MuiTab-root': { fontSize: '18px' } },
  gatewaysAssetsTableSearchWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
  gatewaysAssetsTableSearch: { fontSize: '16px', width: '300px', '@media (max-width: 768px)': { width: '50%' } },
  messageModal: {
    container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
    paper: {
      margin: 'auto',
      boxShadow: '0px 0px 14px 0px #0000000D',
      borderRadius: '18px',
      border: `1px solid #D9DFED`,

      overflow: 'hidden',
    },
    header: {
      p: 3,
      display: 'flex',
      justifyContent: 'flex-end',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      boxSizing: 'border-box',
      // height: '87px',
    },
    searchFieldWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
    dataTableWrapper: {
      height: '100%',
      overflow: 'hidden',
      padding: '24px',
      radius: '18px',
    },
    dataTable: {
      '& .MuiDataGrid-virtualScroller': {
        overflow: 'auto',
      },
      '&.MuiDataGrid-root': {
        height: 'calc(80vh - 196px)',
        minHeight: 'calc(80vh - 196px)',
      },
    },
    closeBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBlock: 4,
      marginTop: '24px',
    },
    tableCellText: {
      fontSize: '16px',
      fontWeight: 400,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  connectedIcon: { paddingLeft: '8px' }, //cursor: 'pointer',
  disConnectedIcon: { cursor: 'pointer', paddingLeft: '8px' },
  disabledIcon: { color: '#A8B1C7', paddingLeft: '8px' },
  veritcalLine: { height: '42px', width: '1px', bgcolor: palette.secondary.main },
};

const TIME_LINE_OPTIONS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  // { label: 'Quarterly', value: 'quarterly' },
  // { label: 'Half-Yearly', value: 'half-yearly' },
  { label: 'Monthly', value: 'monthly' },
  { label: 'Yearly', value: 'yearly' },
];

const getTimePeriod = (timePeriod: string) => {
  let startDate = '';
  const endDate = dayjs().format('MMMM DD, YYYY');

  const daysAgo = (days: number) => {
    return new Date(Date.now() - days * 24 * 60 * 60 * 1000);
  };

  switch (timePeriod) {
    case 'daily':
      startDate = endDate;
      break;
    case 'weekly':
      startDate = dayjs(daysAgo(6)).format('MMMM DD, YYYY');
      break;
    case 'monthly':
      startDate = dayjs(daysAgo(29)).format('MMMM DD, YYYY');
      break;
    case 'quarterly':
      startDate = dayjs(daysAgo(89)).format('MMMM DD, YYYY');
      break;
    case 'half-yearly':
      startDate = dayjs(daysAgo(179)).format('MMMM DD, YYYY');
      break;
    case 'yearly':
      startDate = dayjs(daysAgo(365)).format('MMMM DD, YYYY');
      break;
    default:
      // console.log('DEFAULT');
      break;
  }
  return {
    start_date: startDate,
    end_date: endDate,
  };
};

const TableContainer = ({ children, onViewAll = () => { } }: { children: ReactNode; onViewAll: () => void }) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  return (
    <Container maxWidth={false} disableGutters sx={Styles.tableContainer.container}>
      <Paper
        sx={{
          ...Styles.tableContainer.paper,
          border: `1px solid  ${theme.palette.customBorderColor.main}`,
          backgroundColor: themeMode.isLightBG
            ? lighten(theme.palette.background.default, 0.9)
            : lighten(theme.palette.background.default, 0.05),
        }}
      >
        <div style={{ top: 0 }}>{children}</div>
        <Box sx={Styles.tableContainer.viewAllBtnWrapper}>
          <Button onClick={onViewAll}>View All</Button>
        </Box>
      </Paper>
    </Container>
  );
};

const ChartWrapper = ({ title, children, onFullScreenClick, selectedTimeLine, onSelectTimeLine, loading }: any) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  return (
    <Container maxWidth={false} disableGutters sx={Styles.chartWrapper.container}>
      <Paper
        sx={{
          ...Styles.chartWrapper.paper,
          border: `1px solid  ${theme.palette.customBorderColor.main}`,
          backgroundColor: themeMode.isLightBG
            ? lighten(theme.palette.background.default, 0.9)
            : lighten(theme.palette.background.default, 0.05),
        }}
      >
        <Box sx={Styles.chartWrapper.headerWrapper}>
          <Grid container>
            <Grid item xs={6} display='flex' alignItems='center'>
              <Typography component='h4' fontSize='18px' color={theme.palette.text.primary}>
                {title}
              </Typography>
            </Grid>
            <Grid item xs={6} sx={Styles.chartWrapper.selectWrapper}>
              <SelectComponent
                value={selectedTimeLine}
                options={TIME_LINE_OPTIONS}
                width='250px'
                onChange={onSelectTimeLine}
                sx={Styles.chartWrapper.select}
                MenuProps={Styles.chartWrapper.selectMenuProps}
              />
              <IconButton onClick={onFullScreenClick}>
                <FullScreenIcon style={{ color: theme.palette.text.primary }} />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
        <Box sx={Styles.chartWrapper.bodyWrapper}>
          {loading && (
            <Box sx={Styles.chartWrapper.loadingWrapper}>
              <CircularProgress />
            </Box>
          )}
          {children}
        </Box>
      </Paper>
    </Container>
  );
};

const ChartModalWrapper = ({
  children,
  title = '',
  loading,
  onModalClose,
  onSelectTimeLine,
  selectedTimeLine,
}: any) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});

  return (
    <Dialog
      open
      fullWidth
      PaperProps={{
        sx: {
          ...Styles.chartModal.paperProps.sx,
          backgroundColor: theme.palette.background.default,
        },
      }}
    // sx={{}}
    // onClose={() => {
    //   handleClose();
    // }}
    >
      <DialogContent
        sx={{
          ...Styles.chartModal.dailogContent,
          border: `1px solid  ${theme.palette.customBorderColor.main}`,
          backgroundColor: themeMode.isLightBG
            ? lighten(theme.palette.background.default, 0.9)
            : lighten(theme.palette.background.default, 0.05),
        }}
      // className='modalDialogContent'
      >
        <Box sx={Styles.chartModal.wrapper}>
          <DialogTitle sx={Styles.chartModal.dailogTitle} color={theme.palette.text.primary}>
            {title}
          </DialogTitle>
          <Box sx={Styles.chartModal.headerWrapper}>
            <SelectComponent
              value={selectedTimeLine}
              options={TIME_LINE_OPTIONS}
              width='250px'
              onChange={onSelectTimeLine}
            />
            <IconButton onClick={onModalClose}>
              <FullScreenExitIcon style={{ color: theme.palette.text.primary }} />
            </IconButton>
          </Box>
        </Box>
        <Box sx={Styles.chartModal.bodyWrapper}>
          {loading && (
            <Box sx={Styles.chartModal.loadingWrapper}>
              <CircularProgress />
            </Box>
          )}
          {children}
        </Box>
        <Box sx={Styles.chartModal.closeBtnWrapper}>
          <Button variant='outlined' onClick={onModalClose}>
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

// const getNotificationTypeIcon = (type: string) => {
//   switch (type) {
//     case 'critical':
//       return <AlertRedIcon />;
//     case 'warning':
//       return <AlertIcon />;
//     default:
//       return <BellIcon />;
//   }
// };

const getChipColor = (severity: string) => {
  if (severity === 'critical') return 'error';
  if (severity === 'major') return 'warning';
  if (severity === 'low') return 'success';
  return 'warning';
};

// const getSeverityChip = (severity: string) => {
//   return <Chip label={severity} color={getChipColor(severity)} variant='outlined' sx={Styles.severityChip} />;
// };

const NewConnectivityDashabord = ({
  isOntoManagesLoading,
  // ontoManages,
  assetsLatest,
  assetsLatestLoading,
  gatewaysLatestLoading,
  gatewaysLatest,
  // notificationsLatestLoading,
  // notificationsLatest,
  assetsOnboardingLoading,
  assetsOnboardingData,
  telemetryIngestionLoading,
  telemetryIngestionData,
  // onOntoFilterChange,
  // showFilters,
  ontologyData,
  ontologies,
}: any) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  // const [selectedTab, setSelectedTab] = useState(0);
  const [selectedOntology, setSelectedOntology] = useState(0);

  // const [assetsTableModal, setAssetsTableModal] = useState({ isOpen: false, type: '' });
  // const [gatewaysTableModal, setGatewaysTableModal] = useState({ isOpen: false, type: '' });
  // const [mqBrokerModal, setMqBrokerModal] = useState({ isOpen: false, type: '' });
  // const [influxModal, setInfluxModal] = useState({ isOpen: false, type: '' });
  const [uiServerModal, setUiServerModal] = useState({ isOpen: false, type: '' });
  const [backendServerModal, setBackendServerModal] = useState({ isOpen: false, type: '' });
  const [notificationsTableModal, setNotificationsTableModal] = useState(false);
  const [assetsOnboardModalOpen, setAssetsOnboardModalOpen] = useState(false);
  const [telemetryModalOpen, setTelemetryModalOpen] = useState(false);

  const [assetsSortingModel, setAssetsSortingModel] = useState({ field: '', sort: '' });
  const [assetsSearchValue, setAssetsSearchValue] = useState('');

  const [gatewaysSortingModel, setGatewaysSortingModel] = useState({ field: '', sort: '' });
  const [gatewaysSearchValue, setGatewaysSearchValue] = useState('');

  // const [notificationsSortingModel, setNotificationsSortingModel] = useState({ field: '', sort: '' });
  // const [notificationsSearchValue, setNotificationsSearchValue] = useState('');

  const [assetsOnboardingSelectedTimeLine, setAssetsOnboardingSelectedTimeLine] = useState('daily');
  const [telemetrySelectedTimeLine, setTelemetrySelectedTimeLine] = useState('daily');

  const [assetsList, setAssetsList] = useState<any>([]);
  const [gatewaysList, setGatewaysList] = useState<any>([]);
  const [popupMsgData, setPopupMsgData] = useState<any>({
    status: false,
    title: '',
    type: '',
    item: {},
    connectivityStatus: '',
  });
  // const [assetsLoading, setAssetsLoading] = useState(true);
  // const [gatewaysLoading, setGatewaysLoading] = useState(true);

  const [assetsFilterBy, setAssetsFilterBy] = useState<string[]>([]);
  const [gatewaysFilterBy, setGatewaysFilterBy] = useState<string>('');

  const dispatchGatewaysRequest = (payload: any) => {
    dispatch(
      connectivityDashboardActions.getGatewaysLatestRequest({
        onto_manage_id: selectedOntology,
        search_item: gatewaysSearchValue,
        limit: DEFAULT_PAGE_SIZE,
        page: DEFAULT_PAGE_NUMBER,
        filter_by: gatewaysFilterBy,
        timestamp: new Date().getTime(),
        ...gatewaysSortingModel,
        ...payload,
      })
    );
  };

  const dispatchAssetsRequest = (payload: AssetsRequestPayloadTypes) => {
    dispatch(
      connectivityDashboardActions.getAssetsLatestRequest({
        limit: DEFAULT_PAGE_SIZE,
        page: DEFAULT_PAGE_NUMBER,
        onto_manage_id: selectedOntology,
        search_item: assetsSearchValue,
        filter_by: assetsFilterBy.join(','),
        timestamp: new Date().getTime(),
        ...assetsSortingModel,
        ...payload,
      })
    );
  };

  // const dispatchNotificationsLatestRequest = (payload: any) => {
  //   dispatch(
  //     connectivityDashboardActions.getNotificationsLatestRequest({
  //       onto_manage_id: selectedOntology,
  //       ...notificationsSortingModel,
  //       search_item: notificationsSearchValue,
  //       ...payload,
  //     })
  //   );
  // };

  // const dispatchAssetsOnboardingDataRequest = (payload: AssetsOnboardingDataRequestPayloadTypes) => {
  //   dispatch(connectivityDashboardActions.getAssetsOnboardingDataRequest({ ...payload }));
  // };

  // const dispatchTelemetryDataRequest = (payload: TelemtryIngestionDataRequestPayloadTypes) => {
  //   dispatch(connectivityDashboardActions.getTelemetryIngestionDataRequest({ ...payload }));
  // };

  useEffect(() => {
    dispatch(ontologyMasterActions.getFactoriesOntologiesRequest());
    dispatch(ontologyMasterActions.getOntologyList(''));
    dispatch(ontologyMasterActions.getOntologyMgmntList(''));
    // dispatchAssetsOnboardingDataRequest({
    //   onto_manage_id: selectedOntology,
    //   ...getTimePeriod(assetsOnboardingSelectedTimeLine),
    // });
    // dispatchTelemetryDataRequest({
    //   onto_manage_id: selectedOntology,
    //   ...getTimePeriod(telemetrySelectedTimeLine),
    // });
    // dispatch(connectivityDashboardActions.getGatewaysRequest({ limit: 100, page: 1 }));
    // dispatchAssetsLatestRequest({
    //   limit: 10,
    //   page: DEFAULT_PAGE_NUMBER,
    // });
    // dispatchGatewaysRequest({
    //   limit: 10,
    //   page: DEFAULT_PAGE_NUMBER,
    // });

    return () => {
      dispatch(gatewayMasterActions.resetGatewayMasterData());
      dispatch(connectivityDashboardActions.resetAssetsTable());
      dispatch(connectivityDashboardActions.resetGatewaysTable());
      dispatch(connectivityDashboardActions.resetAssetsHistoryTable());
    };
  }, []);

  useEffect(() => {
    // dispatchNotificationsLatestRequest({
    //   limit: 10,
    //   page: DEFAULT_PAGE_NUMBER,
    // });
    // setAssetsLoading(true);
    // setGatewaysLoading(true);
    dispatchAssetsRequest({});
    dispatchGatewaysRequest({});
    // dispatchAssetsOnboardingDataRequest({
    //   onto_manage_id: selectedOntology,
    //   ...getTimePeriod(assetsOnboardingSelectedTimeLine),
    // });
    // dispatchTelemetryDataRequest({
    //   onto_manage_id: selectedOntology,
    //   ...getTimePeriod(telemetrySelectedTimeLine),
    // });
  }, [selectedOntology]);

  useEffect(() => {
    let assetsInterval: any;
    if (!assetsLatestLoading) {
      assetsInterval = setInterval(() => {
        dispatch(
          connectivityDashboardActions.getAssetsLatestPollingRequest({
            onto_manage_id: selectedOntology,
            search_item: assetsSearchValue,
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            filter_by: assetsFilterBy.join(','),
            timestamp: new Date().getTime(),
            ...assetsSortingModel,
          })
        );
      }, 60000);
    }

    return () => {
      clearInterval(assetsInterval);
    };
  }, [assetsLatestLoading, selectedOntology, assetsSortingModel, assetsSearchValue, assetsFilterBy]);

  useEffect(() => {
    let gatewaysInterval: any;
    if (!gatewaysLatestLoading) {
      gatewaysInterval = setInterval(() => {
        dispatch(
          connectivityDashboardActions.getGatewaysLatestPollingRequest({
            onto_manage_id: selectedOntology,
            search_item: gatewaysSearchValue,
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            timestamp: new Date().getTime(),
            ...gatewaysSortingModel,
          })
        );
      }, 60000);
    }

    return () => {
      clearInterval(gatewaysInterval);
    };
  }, [gatewaysLatestLoading, selectedOntology, gatewaysSortingModel, gatewaysSearchValue]);

  const onConnectionClick = (item: string, type: string) => {
    navigate(`/connectivity-dashboard/${item}/${selectedOntology}/${type}`);
    // if (item === 'assets') {
    //   // dispatch(connectivityDashboardActions.resetAssetsTable());
    //   navigate(`/connectivity-dashboard/${item}/${selectedOntology}/${type}`);
    // } else if (item === 'gateways') {
    //   // dispatch(connectivityDashboardActions.resetGatewaysTable());
    //   navigate(`/connectivity-dashboard/${item}/${selectedOntology}/${type}`);
    // } else {
    //   navigate(`/connectivity-dashboard/${item}/${type}`);
    // }
    // if (item === 'assets') {
    //   // setAssetsTableModal({ isOpen: true, type });
    //   navigate(`/connectivity-dashboard/assets/${type}`)
    // }
    // if (item === 'gateways') {
    //   // setGatewaysTableModal({ isOpen: true, type });
    //   navigate(`/connectivity-dashboard/gateways/${type}`)
    // }
    // if (item === 'mqbroker') {
    //   // setMqBrokerModal({ isOpen: true, type });
    //   navigate(`/connectivity-dashboard/mqbroker/${type}`)
    // }
    // if (item === 'influx') {
    //   // setInfluxModal({ isOpen: true, type });
    //   navigate(`/connectivity-dashboard/influx/${type}`)
    // }
    // if (item === 'uiserver') {
    //   // setUiServerModal({ isOpen: true, type });
    //   navigate(`/connectivity-dashboard/assets/${type}`)
    // }
    // if (item === 'backendserver') {
    //   // setBackendServerModal({ isOpen: true, type });
    //   navigate(`/connectivity-dashboard/assets/${type}`)
    // }
  };

  const getOntologyData = (ontoId: any) => {
    if (ontologies.length > 0) {
      let tempOntoData: any = [];
      restartTheLoop: while (true) {
        for (const item of ontologies) {
          if (item.onto_manage_id == ontoId) {
            tempOntoData.unshift(item);
            ontoId = item.parent_id;
            continue restartTheLoop;
          }
        }
        break;
      }

      tempOntoData.map((item: any) => {
        let getLevelName = ontologyData.filter((data: any) => {
          return data.id === item.onto_level_number;
        })[0];

        return {
          ...item,
          level_name: getLevelName?.level_name || '',
        };
      });

      return tempOntoData;
    }
    return [];
  };

  useEffect(() => {
    if (assetsLatest.length > 0 && ontologies.length) {
      setAssetsList(
        assetsLatest.map((item: any) => {
          return {
            ...item,
            ontologyList: getOntologyData(item.onto_manage_id),
          };
        })
      );
    } else {
      setAssetsList([]);
    }
  }, [assetsLatest, ontologies]);

  useEffect(() => {
    if (gatewaysLatest.length > 0 && ontologies.length) {
      setGatewaysList(
        gatewaysLatest.map((item: any) => {
          return {
            ...item,
            ontologyList: getOntologyData(item.onto_manage_id),
          };
        })
      );
    } else {
      setGatewaysList([]);
    }
  }, [gatewaysLatest, ontologies]);

  const connectedIconStyle = { ...Styles.connectedIcon, color: theme.palette.success.main };
  const disconnectedIconStyle = { ...Styles.disConnectedIcon, color: theme.palette.error.main };

  const gatewayColumns: GridColDef[] = [
    {
      field: 'gateway_name',
      headerName: 'Gateway Name',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 188,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography component='p' sx={Styles.tableCellText}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'assets_count',
      headerName: 'Assets Connected',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 205,
      renderCell: (params) => (
        <Typography
          component='p'
          sx={{
            fontSize: '16px',
            fontWeight: 400,
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'location',
      headerName: 'Location',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 128,
      renderCell: (params: any) => {
        const ontoList =
          params.row.ontologyList && params.row.ontologyList.length
            ? params.row.ontologyList.map((item: any, index: number) =>
              params.row.ontologyList.length > 1 ? (
                index === params.row.ontologyList.length - 1 ? (
                  <span>{item.onto_manage_title} </span>
                ) : (
                  <span>{item.onto_manage_title} / </span>
                )
              ) : (
                <span>{item.onto_manage_title}</span>
              )
            )
            : '';

        return (
          <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '120px' }}>
            <Tooltip title={ontoList} placement='left' arrow>
              <Typography
                component='p'
                sx={{
                  textOverflow: 'ellipsis',
                  fontSize: '16px !important',
                  fontWeight: '400',
                  lineHeight: '1.5',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                {ontoList}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'last_connected',
      headerName: 'Last Connected',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 202,
      renderCell: (params) => {
        const lastConnected = convertUTCtoLocal(params.value);
        return (
          <Tooltip title={lastConnected} arrow>
            <Typography component='p' sx={Styles.tableCellText}>
              {lastConnected}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'connectivity_status',
      headerName: 'Status',
      headerAlign: 'center',
      align: 'center',
      width: 120,
      renderCell: (params) => {
        if (params.row.connectivity_status === 'connected') {
          return <GatewayConnectedIcon style={{ ...connectedIconStyle, paddingLeft: 0 }} />
        } else if (params.row.connectivity_status === 'disconnected') {
          return (
            <GatewayDisconnectedIcon
              style={{ ...disconnectedIconStyle, paddingLeft: 0 }}
              onClick={() => handleMessagePopupOpen('Gateway Connection', 'Disconnected', params?.row?.latest_message)}
            />
          );
        } else {
          return <GatewayConnectedIcon style={{ ...Styles.disabledIcon, paddingLeft: 0 }} />;
        }
      },
      minWidth: 100,
    },
  ];

  const assetColumns: GridColDef[] = [
    {
      field: 'asset_ip',
      headerName: 'Asset IP',
      headerAlign: 'left',
      align: 'left',
      minWidth: 125,
    },
    {
      field: 'asset_name',
      headerName: 'Asset Name',
      headerAlign: 'left',
      align: 'left',
      minWidth: 145,
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            component={Link}
            to={`/connectivity-dashboard/assethistory/${params.row.component_id}`}
            sx={{ ...Styles.tableCellText, color: theme.palette.primary.main, textDecoration: 'none' }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'location',
      headerName: 'Location',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 130,
      renderCell: (params: any) => {
        const ontoList =
          params.row.ontologyList && params.row.ontologyList.length
            ? params.row.ontologyList.map((item: any, index: number) =>
              params.row.ontologyList.length > 1 ? (
                index === params.row.ontologyList.length - 1 ? (
                  <span>{item.onto_manage_title} </span>
                ) : (
                  <span>{item.onto_manage_title} / </span>
                )
              ) : (
                <span>{item.onto_manage_title}</span>
              )
            )
            : '';

        return (
          <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '120px' }}>
            <Tooltip title={ontoList} placement='left' arrow>
              <Typography
                component='p'
                sx={{
                  textOverflow: 'ellipsis',
                  fontSize: '16px !important',
                  fontWeight: '400',
                  lineHeight: '1.5',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                {ontoList}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'last_connected',
      headerName: 'Last Connected',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 205,
      renderCell: (params) => {
        const lastConnected = convertUTCtoLocal(params.value);
        return (
          <Tooltip title={lastConnected} arrow>
            <Typography component='p' sx={Styles.tableCellText}>
              {lastConnected}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'connectivity_status',
      headerName: 'Status',
      // flex: 1,
      headerAlign: 'center',
      align: 'center',
      width: 130,
      renderCell: (params) => {
        const statusContainer = (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            {params.row.connectivity_status === 'connected' ? (
              <EmqxConnectedIcon style={{ ...connectedIconStyle, paddingLeft: 0 }} />
            ) : params.row.connectivity_status === 'disconnected' ? (
              <EmqxDisconnectedIcon
                style={{ ...disconnectedIconStyle, padding: 0 }}
                onClick={() =>
                  handleMessagePopupOpen('MQTT Broker Connection', 'Disconnected', params.row?.connectivity_msg)
                }
              />
            ) : (
              <EmqxConnectedIcon style={{ ...Styles.disabledIcon, padding: 0 }} />
            )}
            {params.row.plc_status === 'connected' ? (
              <PlcConnected style={connectedIconStyle} />
            ) : params.row.plc_status === 'disconnected' ? (
              <PlcDisconnected
                style={disconnectedIconStyle}
                onClick={() => handleMessagePopupOpen('PLC Server Connection', 'Disconnected', params.row?.plc_msg)}
              />
            ) : (
              <PlcConnected style={Styles.disabledIcon} />
            )}
            {params.row.data_status === 'connected' ? (
              <DataConnected style={connectedIconStyle} />
            ) : params.row.data_status === 'disconnected' ? (
              <DataDisconnected
                style={disconnectedIconStyle}
                onClick={() => handleMessagePopupOpen('Data Server Connection', 'Disconnected', params.row?.data_msg)}
              />
            ) : (
            <DataConnected style={Styles.disabledIcon} />
            )}
          </Box>
        );
        return statusContainer;
      },
      minWidth: 100,
    },
  ];

  // const notificationColumns: GridColDef[] = [
  //   {
  //     field: 'type',
  //     headerName: 'Type',
  //     headerAlign: 'center',
  //     align: 'center',
  //     width: 120,
  //     renderCell: (params) => {
  //       return getNotificationTypeIcon(params.row.type);
  //     },
  //   },
  //   {
  //     field: 'originator',
  //     headerName: 'Originator',
  //     headerAlign: 'left',
  //     align: 'left',
  //     minWidth: 100,
  //     width: 150,
  //     renderCell: (params) => (
  //       <Tooltip title={params.value} arrow>
  //         <Typography component='p' sx={Styles.tableCellText}>
  //           {params.value}
  //         </Typography>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     field: 'message',
  //     headerName: 'Message',
  //     flex: 1,
  //     headerAlign: 'left',
  //     align: 'left',
  //     minWidth: 100,
  //     renderCell: (params) => (
  //       <Tooltip title={params.value} arrow>
  //         <Typography component='p' sx={Styles.tableCellText}>
  //           {params.value}
  //         </Typography>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     field: 'last_connected',
  //     headerName: 'Date',
  //     headerAlign: 'left',
  //     align: 'left',
  //     width: 200,
  //     renderCell: (params) => (
  //       <Tooltip title={params.value} arrow>
  //         <Typography component='p' sx={Styles.tableCellText}>
  //           {params.value}
  //         </Typography>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     field: 'severity',
  //     headerName: 'Severity',
  //     headerAlign: 'left',
  //     align: 'left',
  //     width: 150,
  //     renderCell: (params) => {
  //       return getSeverityChip(params.row.severity);
  //     },
  //   },
  // ];

  // const onAssetsOnboardingSelectTimeline = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setAssetsOnboardingSelectedTimeLine(e.target.value);
  //   dispatchAssetsOnboardingDataRequest({ onto_manage_id: selectedOntology, ...getTimePeriod(e.target.value) });
  // };

  // const onTelemetrySelectTimeLine = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setTelemetrySelectedTimeLine(e.target.value);
  //   dispatchTelemetryDataRequest({ onto_manage_id: selectedOntology, ...getTimePeriod(e.target.value) });
  // };

  const getOntoSelectedValue = (e: any) => {
    setSelectedOntology(e?.onto_manage_id);
  };
  const navigate = useNavigate();

  const handleMessagePopupOpen = (title: string, type: any, item: any) => {
    setPopupMsgData({ status: true, title: title, type: type, item: item || {} });
  };
  const handleMsgPopupClose = () => {
    setPopupMsgData({ status: false, title: '', type: '', item: {}, connectivityStatus: '' });
  };

  const onAssetsFilterBy = (key: string) => {
    const filterByStatuses = assetsFilterBy.includes(key)
      ? assetsFilterBy.filter((status: string) => status !== key)
      : [...assetsFilterBy, key];

    dispatchAssetsRequest({ filter_by: filterByStatuses.join(',') });

    setAssetsFilterBy(filterByStatuses);
  };

  const onGatewaysFilterBy = (key: string) => {
    const filterByStatus = gatewaysFilterBy ? '' : key;
    dispatchGatewaysRequest({ filter_by: filterByStatus });
    setGatewaysFilterBy(filterByStatus);
  };

  return (
    <Box sx={Styles.pageWrapper}>
      <FilterData
        isOntoManagesLoading={isOntoManagesLoading}
        ontologyData={ontologyData}
        showLayout={true}
        onOntoFilterChange={getOntoSelectedValue}
        isFrom={'health'}
      />
      <Connections onConnectionClick={onConnectionClick} ontoManageId={selectedOntology} />
      <Grid container spacing={4} sx={{ minHeight: '210px' }}>
        <Grid item xs={12} md={12} lg={6}>
          <TableContainer
            onViewAll={() => {
              // dispatch(connectivityDashboardActions.resetAssetsTable());
              navigate(`/connectivity-dashboard/assets/${selectedOntology}/viewall`);
            }}
          >
            <Box sx={Styles.chartWrapper.headerWrapper}>
              <Box>
                <Typography component='h4' fontSize='18px' color={theme.palette.text.primary}>
                  List of Assets
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2, flexWrap: 'wrap', rowGap: 1 }}>
                <Box sx={{ display: 'flex', columnGap: '12px' }}>
                  <Box sx={{ display: 'flex', columnGap: 1 }}>
                    <FilterIcon style={{ color: theme.palette.custom.light }} />
                    <Typography sx={{ fontSize: '16px' }}>Filter By :</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                    <IconButton sx={{ p: 0 }} onClick={() => onAssetsFilterBy('connectivity_status')}>
                      <EmqxDisconnectedIcon
                        style={{
                          color: assetsFilterBy.includes('connectivity_status') ? palette.error.main : '#A8B1C7',
                        }}
                      />
                    </IconButton>
                    <IconButton sx={{ p: 0 }} onClick={() => onAssetsFilterBy('plc_status')}>
                      <PlcDisconnected
                        style={{ color: assetsFilterBy.includes('plc_status') ? palette.error.main : '#A8B1C7' }}
                      />
                    </IconButton>
                    <IconButton sx={{ p: 0 }} onClick={() => onAssetsFilterBy('data_status')}>
                      <DataDisconnected
                        style={{ color: assetsFilterBy.includes('data_status') ? palette.error.main : '#A8B1C7' }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                <Box sx={Styles.veritcalLine} />
                <SearchField
                  searchPlaceholder='Search'
                  defaultValue={assetsSearchValue}
                  onSearch={(searchValue: string) => {
                    dispatchAssetsRequest({
                      search_item: searchValue,
                    });
                    setAssetsSearchValue(searchValue);
                  }}
                  // key={selectedTab}
                  width='100%'
                  sx={Styles.gatewaysAssetsTableSearch}
                />
              </Box>
            </Box>
            <DataTable
              // key={selectedTab}
              rows={assetsList}
              columns={assetColumns}
              loading={assetsLatestLoading}
              hideFooter
              tableStyles={Styles.dataTable}
              isServerPagination
              totalRowCount={DEFAULT_PAGE_SIZE}
              pageNumber={DEFAULT_PAGE_NUMBER}
              onSorting={(sortModel: { field: string; sort: string }) => {
                dispatchAssetsRequest({
                  ...sortModel,
                });
                setAssetsSortingModel(sortModel);
              }}
              otherProps={{
                getRowId: (row: any) => row.component_id,
                rowHeight: 48,
              }}
            />
          </TableContainer>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <TableContainer
            onViewAll={() => {
              // dispatch(connectivityDashboardActions.resetGatewaysTable());
              navigate(`/connectivity-dashboard/gateways/${selectedOntology}/viewall`);
            }}
          >
            <Box sx={Styles.chartWrapper.headerWrapper}>
              <Box>
                <Typography component='h4' fontSize='18px' color={theme.palette.text.primary}>
                  List of Gateways
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2 }}>
                <Box sx={{ display: 'flex', columnGap: '12px' }}>
                  <Box sx={{ display: 'flex', columnGap: 1 }}>
                    <FilterIcon style={{ color: theme.palette.custom.light }} />
                    <Typography sx={{ fontSize: '16px' }}>Filter By :</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                    <IconButton sx={{ p: 0 }} onClick={() => onGatewaysFilterBy('connectivity_status')}>
                      <GatewayDisconnectedIcon
                        style={{
                          color: gatewaysFilterBy ? palette.error.main : '#A8B1C7',
                        }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                <Box sx={Styles.veritcalLine} />
                <SearchField
                  searchPlaceholder='Search'
                  defaultValue={gatewaysSearchValue}
                  onSearch={(searchValue: string) => {
                    dispatchGatewaysRequest({
                      search_item: searchValue,
                    });
                    setGatewaysSearchValue(searchValue);
                  }}
                  // key={selectedTab}
                  width='100%'
                  sx={Styles.gatewaysAssetsTableSearch}
                />
              </Box>
            </Box>
            <Box
              sx={{
                height: '100%',
                overflow: 'hidden',
              }}
            >
              <DataTable
                // key={selectedTab}
                rows={gatewaysList}
                columns={gatewayColumns}
                loading={gatewaysLatestLoading}
                hideFooter
                tableStyles={Styles.dataTable}
                isServerPagination
                totalRowCount={DEFAULT_PAGE_SIZE}
                pageNumber={DEFAULT_PAGE_NUMBER}
                onSorting={(sortModel: { field: string; sort: string }) => {
                  dispatchGatewaysRequest({
                    ...sortModel,
                  });
                  setGatewaysSortingModel(sortModel);
                }}
                otherProps={{
                  getRowId: (row: any) => row.gateway_id,
                  rowHeight: 48,
                }}
              />
            </Box>
          </TableContainer>
        </Grid>
      </Grid>
      {/* <Grid container spacing={4}>
        <Grid item xs={12} md={12} lg={6}>
          <ChartWrapper
            title='Assets Onboarding Status'
            onFullScreenClick={() => setAssetsOnboardModalOpen(true)}
            selectedTimeLine={assetsOnboardingSelectedTimeLine}
            onSelectTimeLine={onAssetsOnboardingSelectTimeline}
            loading={assetsOnboardingLoading}
          >
            <AssetsOnboardingStatusChart
              chartData={assetsOnboardingData}
              selectedTimeLine={assetsOnboardingSelectedTimeLine}
            />
          </ChartWrapper>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <ChartWrapper
            title='Telemetry Data Ingestion'
            onFullScreenClick={() => setTelemetryModalOpen(true)}
            selectedTimeLine={telemetrySelectedTimeLine}
            onSelectTimeLine={onTelemetrySelectTimeLine}
            loading={telemetryIngestionLoading}
          >
            <TelemetryDataIngestionChart
              selectedTimeLine={telemetrySelectedTimeLine}
              chartData={telemetryIngestionData}
            />
          </ChartWrapper>
        </Grid>
      </Grid> */}
      {/* {assetsOnboardModalOpen && (
        <ChartModalWrapper
          title='Assets Onboarding Status'
          loading={assetsOnboardingLoading}
          onModalClose={() => setAssetsOnboardModalOpen(false)}
          onSelectTimeLine={onAssetsOnboardingSelectTimeline}
          selectedTimeLine={assetsOnboardingSelectedTimeLine}
        >
          <AssetsOnboardingStatusChart
            selectedTimeLine={assetsOnboardingSelectedTimeLine}
            chartData={assetsOnboardingData}
          />
        </ChartModalWrapper>
      )} */}
      {/* {telemetryModalOpen && (
        <ChartModalWrapper
          title='Telemetry Data Ingestion'
          loading={telemetryIngestionLoading}
          onModalClose={() => setTelemetryModalOpen(false)}
          onSelectTimeLine={onTelemetrySelectTimeLine}
          selectedTimeLine={telemetrySelectedTimeLine}
        >
          <TelemetryDataIngestionChart
            selectedTimeLine={telemetrySelectedTimeLine}
            chartData={telemetryIngestionData}
          />
        </ChartModalWrapper>
      )} */}

      {uiServerModal.isOpen && (
        <UIServerTable
          onModalClose={() => {
            setUiServerModal({ isOpen: false, type: '' });
          }}
          type={uiServerModal.type}
          selectedOntology={selectedOntology}
        />
      )}

      {backendServerModal.isOpen && (
        <BackendServerTable
          onModalClose={() => {
            setBackendServerModal({ isOpen: false, type: '' });
          }}
          type={backendServerModal.type}
          selectedOntology={selectedOntology}
        />
      )}

      {notificationsTableModal && (
        <NotificationsTable
          title='ALERTS & NOTIFICATIONS'
          onModalClose={() => setNotificationsTableModal(false)}
          selectedOntology={selectedOntology}
        />
      )}

      {popupMsgData.status && (
        <LatestMessagePopup popupMsgData={popupMsgData} handleMsgPopupClose={handleMsgPopupClose} />
      )}
    </Box>
  );
};

const mapStateToProps = (state: any) => ({
  ontoManages: state.ontologyMaster.OntoManages,
  isOntoManagesLoading: state.ontologyMaster.isOntoManagesLoading,
  assetsLatest: state.connectivityDashboard.assetsLatest,
  assetsLatestLoading: state.connectivityDashboard.assetsLatestLoading,
  gatewaysLatest: state.connectivityDashboard.gatewaysLatest,
  gatewaysLatestLoading: state.connectivityDashboard.gatewaysLatestLoading,
  notificationsLatestLoading: state.connectivityDashboard.notificationsLatestLoading,
  notificationsLatest: state.connectivityDashboard.notificationsLatest,
  assetsOnboardingLoading: state.connectivityDashboard.assetsOnboardingLoading,
  assetsOnboardingData: state.connectivityDashboard.assetsOnboardingData,
  telemetryIngestionLoading: state.connectivityDashboard.telemetryIngestionLoading,
  telemetryIngestionData: state.connectivityDashboard.telemetryIngestionData,
  ontologyData: state.ontologyMaster.ontologyData,
  ontologies: state.ontologyMaster.ontologyMgmntData,
});

export default connect(mapStateToProps)(NewConnectivityDashabord);
